/**
 * Контроллер секции для управления анимациями по событиям fullpage.js
 *
 * @param $section
 * @constructor
 */
export default function SectionController($section) {
    this.$section = $section;

    this.id = getSectionName(this.$section).replace(' ', '-');
};

SectionController.prototype.onBottomLeave = function() {
    logAction(this.$section, 'on bottom leave')
    this.animateOnLeave();
};

SectionController.prototype.onTopEnter = function() {
    logAction(this.$section, 'on top enter')
    this.animateOnEnter();
};

SectionController.prototype.onTopLeave = function() {
    logAction(this.$section, 'on top leave')
    this.revertAnimateOnEnter();
};

SectionController.prototype.onBottomEnter = function() {
    logAction(this.$section, 'on bottom enter')
    this.revertAnimateOnLeave();
};

SectionController.prototype.animateOnEnter = function() {
    logAction(this.$section, 'animateOnEnter')
};

SectionController.prototype.animateOnLeave = function() {
    logAction(this.$section, 'animateOnLeave')
};

SectionController.prototype.revertAnimateOnEnter = function() {
    logAction(this.$section, 'revertAnimateOnEnter')
};

SectionController.prototype.revertAnimateOnLeave = function() {
    logAction(this.$section, 'revertAnimateOnLeave')
};

// TODO delete
function getSectionName(item) {
    var name = $(item).attr('id') ? $(item).attr('id') : $(item).attr('class');

    return name.split(' ').slice(0, 2).join(' ');
}

function logAction($section, action) {
    /*
    console.log(
        '%c ' + action + ' ' + '%c' + getSectionName($section),
        'color:green; font-weight: bold;',
        'color:black; font-weight: normal;'
    );
    //*/
}